package one.devsbox.www.ui.widgets

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.GridOutline
import compose.assets.svg.ListBoxOutline

enum class EntryViewMode { Card, List }

@Composable
fun EntryViewSwitch(mode: EntryViewMode, onChange: (EntryViewMode) -> Unit) {
    Row {
        val selectedColor = MaterialTheme.colorScheme.secondaryContainer.copy(alpha = 0.8F)
        val unselectedColor = Color.Transparent

        Box(
            modifier = Modifier
                .align(Alignment.CenterVertically)
                .size(32.dp)
                .border(
                    width = 1.dp,
                    color = MaterialTheme.colorScheme.outlineVariant,
                    shape = MaterialTheme.shapes.large
                )
                .background(
                    if (mode == EntryViewMode.Card) selectedColor else unselectedColor,
                    MaterialTheme.shapes.large
                )
                .clickable { onChange(EntryViewMode.Card) }
                .padding(8.dp),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                Svg.GridOutline,
                null,
                modifier = Modifier.fillMaxSize()
            )
        }
        Spacer(Modifier.size(4.dp))
        Box(
            modifier = Modifier
                .align(Alignment.CenterVertically)
                .size(32.dp)
                .border(
                    width = 1.dp,
                    color = MaterialTheme.colorScheme.outlineVariant,
                    shape = MaterialTheme.shapes.large
                )
                .background(
                    if (mode == EntryViewMode.List) selectedColor else unselectedColor,
                    MaterialTheme.shapes.large
                )
                .clickable { onChange(EntryViewMode.List) }
                .padding(8.dp),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                Svg.ListBoxOutline,
                null,
                modifier = Modifier.fillMaxSize()
            )
        }
    }
}